import { useCommitDiffDiscussions } from '../commit_discussions_store.js?vue3';
import { pinia } from '../../../pinia/instance.js?vue3';

export const commitDiffDiscussionsStore = useCommitDiffDiscussions(pinia);
